import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { ButtonComponent, IconComponent } from '@mode/capra';
import { ReportSchedule } from '@mode/shared/schedules/contract';

@Component({
  standalone: true,
  imports: [CommonModule, MatLegacyMenuModule, MatDividerModule, IconComponent, ButtonComponent],
  selector: 'mode-schedule-list-actions',
  templateUrl: './schedule-list-actions.component.html',
  styleUrls: ['./schedule-list-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleListActionsComponent {
  @Input({ required: true }) schedule!: ReportSchedule;
  @Output() deleteSchedule = new EventEmitter<void>();
  @Output() editSchedule = new EventEmitter<void>();
  @Output() createOrDeleteSubscription = new EventEmitter<void>();
}
